import { render } from "./MyPopUpWindowFooterButtonConfirm.vue?vue&type=template&id=4b8307e4"
import script from "./MyPopUpWindowFooterButtonConfirm.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindowFooterButtonConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__